import { z } from 'zod';
import { phoneSchema } from './common.js';
/**
 * Mijozning qo'shimcha kontaktlari.
 *
 * Alif talabi (Broker API, `POST /core/clients/additional-data`):
 *   • kamida 2 ta kontakt;
 *   • kamida bittasi yaqin qarindosh bo'lishi shart;
 *   • kontakt raqami mijozning o'z raqami bilan bir xil bo'lmasligi kerak.
 *
 * Uchala qoidani ham frontendда tekshiramiz: aks holda sotuvchi xatoni
 * faqat scoring paytida, Alif rad etgandan keyin ko'rardi.
 */
/** Alif hujjatidagi kontakt turlari. */
export const ContactNote = {
    PARENT: 'parent',
    SPOUSE: 'spouse',
    CHILD: 'child',
    SIBLINGS: 'siblings',
    FAMILY: 'family',
    PROGENITOR: 'progenitor',
    GRANDCHILD: 'grandchild',
    FRIEND: 'friend',
    COLLEAGUE: 'colleague',
    ADDITIONAL: 'additional',
};
export const CONTACT_NOTES = {
    parent: { closeRelative: true },
    spouse: { closeRelative: true },
    child: { closeRelative: true },
    siblings: { closeRelative: true },
    family: { closeRelative: true },
    progenitor: { closeRelative: false },
    grandchild: { closeRelative: false },
    friend: { closeRelative: false },
    colleague: { closeRelative: false },
    additional: { closeRelative: false },
};
export const CLOSE_RELATIVE_NOTES = Object.keys(CONTACT_NOTES).filter((note) => CONTACT_NOTES[note].closeRelative);
export function isCloseRelative(note) {
    return CONTACT_NOTES[note]?.closeRelative ?? false;
}
const VALID_PHONE = /^998\d{9}$/;
export const clientContactSchema = z.object({
    note: z.nativeEnum(ContactNote),
    /** Alif maydoni `body` deb ataladi. */
    phone: phoneSchema,
    name: z.string().trim().min(2, 'v.contactName'),
});
/** Alifning uchala qoidasi. */
export const clientContactsSchema = z
    .array(clientContactSchema)
    .min(2, 'v.contactsMin')
    .max(10)
    .refine((contacts) => contacts.some((c) => isCloseRelative(c.note)), {
    message: 'v.contactsCloseRelative',
})
    .refine((contacts) => {
    // Faqat to'g'ri kiritilgan raqamlarni solishtiramiz. Aks holda ikkita
    // hali to'ldirilmagan qator ham «bir xil raqam» bo'lib chiqadi va
    // sotuvchi hech narsa yozmasdan turib xato ko'radi. Yaroqsiz raqam
    // haqida maydonning o'z xatosi allaqachon aytadi.
    const filled = contacts.map((c) => c.phone).filter((p) => VALID_PHONE.test(p));
    return new Set(filled).size === filled.length;
}, { message: 'v.contactsDuplicate' });
/**
 * Mijozning o'z raqami kontaktlar orasida bo'lmasligini tekshiradi.
 * Alif buni `corresponds_with_client_number` xatosi bilan rad etadi.
 */
export function conflictsWithClientPhone(contacts, clientPhone) {
    const own = clientPhone.replace(/\D/g, '');
    if (!VALID_PHONE.test(own))
        return false;
    return contacts.some((c) => c.phone.replace(/\D/g, '') === own);
}
//# sourceMappingURL=contacts.js.map